import { IFinancingInsight } from "../types/ownerDashboard.types";

export function getFinancingProgressPct(insight: IFinancingInsight): number {
  if (insight.covers_installment) {
    return 100;
  }

  const progressPct = insight.milestone_progress_pct ?? insight.coverage_pct ?? 0;

  return Math.min(100, Math.max(0, progressPct));
}
